import { useEffect } from "react";
import { useSetAtom } from "jotai";
import { userPhotoUrlAtom } from "@store/HostAtoms";
import { useAccessToken } from "@hooks/useAccessToken";

export const useUserPhoto = (isAuthenticated: boolean) => {
  const setUserPhoto = useSetAtom(userPhotoUrlAtom);
  const getAccessToken = useAccessToken();

  useEffect(() => {
    if (!isAuthenticated) return;

    const fetchPhoto = async (accessToken: string): Promise<string | null> => {
      try {
        const response = await fetch(
          "https://graph.microsoft.com/v1.0/me/photo/$value",
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          }
        );

        if (!response.ok) {
          console.warn("Profile image fetch failed", response.status);
          return null;
        }

        const blob = await response.blob();
        return URL.createObjectURL(blob);
      } catch (err) {
        console.error("Error fetching user profile image:", err);
        return null;
      }
    };

    const getPhoto = async () => {
      try {
        const token = await getAccessToken({ scopes: ["User.Read"] });
        if (!token) return;

        const imageUrl = await fetchPhoto(token);
        if (imageUrl) setUserPhoto(imageUrl);

      } catch (error: any) {
        console.error("Photo fetch failed:", error);
      }
    };

    getPhoto();
  }, [isAuthenticated, getAccessToken, setUserPhoto]);
};